module.exports = __webpack_public_path__ + "static/media/day17_todolist.6426afef.gif";